<app-header [label]="page_name | plural"></app-header>
<app-ag-grid-list [list]="items" [colDefs]="country_cols" [itemName]="page_name" (fetch_new_list)="get_list($event)" (bulkDelete)="bulk_delete($event)">
  <div toolbar class="flex bg-white gap-4 items-center justify-between p-4 border-b border-gray-300">
    <app-search-input #searchbar (fetch_new_list)="get_list($event)"></app-search-input>
    <div class="flex gap-2">
        <app-button color="bg-secondary text-[#310000]" [label]="page_name" icon="bx bx-plus" (click)="open_form_modal()"></app-button>
        <app-button color="bg-secondary text-[#310000]" [label]="`Add Bulk ${page_name | plural}`" icon="bx bx-plus" (click)="bulk_modal.open()"></app-button>
    </div>
  </div>
</app-ag-grid-list>
<app-confirmation-popup #confirmation_delete_modal label="Delete {{page_name}}?" [delete_icon]="true" cancelText="No" confirmColor="bg-[#FA2912] text-[#FFFFFF]" confirmText="Yes" [is_mandatory]="true" (confirm_modal_clicked)="delete_program()" (close_modal_clicked)="confirmation_delete_modal.close()">
    This action cannot be undone, and all associated data will be permanently removed.
</app-confirmation-popup>
<app-modal #form_modal [label]="`${selected_program_ids.id ? 'Update' : 'Add'} ${page_name}`">
    <form [formGroup]="form">
        <div class="py-2 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4">
            <app-select-input label="University" class="w-full" formControlName="university_id" [options]="ds.dropdown_list?.university_list"></app-select-input>
            <app-select-input label="Stream" class="w-full" formControlName="stream_id" [options]="ds.dropdown_list?.stream_list"></app-select-input>
            <app-select-input label="Program" class="w-full" formControlName="program_id" [options]="ds.dropdown_list?.program_list"></app-select-input>
            <app-text-input class="w-full" [label]="page_name + ' Name'" formControlName="name"></app-text-input>
            <app-text-input class="w-full" [label]="page_name + ' Code'" formControlName="code"></app-text-input>
            <app-text-input class="w-full" [label]="page_name + ' Credits'" formControlName="credits"></app-text-input>
            <app-text-input class="w-full" [label]="page_name + ' Owner'" formControlName="owner"></app-text-input>
            <app-text-input class="w-full" [label]="page_name + ' Email'" formControlName="email"></app-text-input>
            <app-text-input class="w-full" [label]="page_name + ' Contact'" formControlName="contact"></app-text-input>
        </div>
        <div class="flex justify-end items-center gap-2 mt-2">
            <app-button color="border-primary text-primary" label="Cancel" type="button" (click)="close_form_modal()"></app-button>
            <app-button color="bg-secondary text-black" [label]="selected_program_ids.id ? 'Update' :'Add'" type="button" (click)="submit_program()"></app-button>
        </div>
    </form>
</app-modal>
<app-modal #bulk_modal label="Bulk Upload {{page_name | plural}}" sub_label="Add {{ page_name }} in Bulk">
    <app-bulk-upload [title]="page_name" [cancel]="bulk_modal" [accepted_type]="['.csv']" [max_file_sizeMB]="5" [bulk_columns]="bulk_columns" (submit)="bulk_upload($event.data,$event.spinner)"></app-bulk-upload>
</app-modal>

<app-modal #view_modal [label]="'View '+ page_name" width="md" (close_modal_clicked)="view_modal.close()">
    <div class="grid grid-cols-1 md:grid-cols-3 gap-6 text-sm">
        <div class="p-2 break-words">
            <p class="font-semibold text-gray-700">University</p>
            <p class="text-gray-900 mt-1">{{ selected_program_ids?.university?.name || '—' }}</p>
        </div>
        <div class="p-2 break-words">
            <p class="font-semibold text-gray-700">Stream Name</p>
            <p class="text-gray-900 mt-1">{{ selected_program_ids?.stream?.name || '—' }}</p>
        </div>
        <div class="p-2 break-words">
            <p class="font-semibold text-gray-700">Program Name</p>
            <p class="text-gray-900 mt-1">{{ selected_program_ids?.program?.name || '—' }}</p>
        </div>
        <div class="p-2 break-words">
            <p class="font-semibold text-gray-700">{{page_name}} Name</p>
            <p class="text-gray-900 mt-1">{{ selected_program_ids?.name || '—' }}</p>
        </div>
        <div class="p-2 break-words">
            <p class="font-semibold text-gray-700">{{page_name}} Code</p>
            <p class="text-gray-900 mt-1">{{ selected_program_ids?.code || '—' }}</p>
        </div>
        <div class="p-2 break-words">
            <p class="font-semibold text-gray-700">{{page_name}} Owner</p>
            <p class="text-gray-900 mt-1">{{ selected_program_ids?.owner || '—' }}</p>
        </div>
        <div class="p-2 break-words">
            <p class="font-semibold text-gray-700">{{page_name}} Credits/p>
            <p class="text-gray-900 mt-1">{{ selected_program_ids?.credits || '—' }}</p>
        </div>
        <div class="p-2 break-words">
            <p class="font-semibold text-gray-700">{{page_name}} Email</p>
            <p class="text-gray-900 mt-1">{{ selected_program_ids?.email || '—' }}</p>
        </div>
        <div class="p-2 break-words">
            <p class="font-semibold text-gray-700">{{page_name}} Contact</p>
            <p class="text-gray-900 mt-1">{{ selected_program_ids?.contact || '—' }}</p>
        </div>

    </div>
</app-modal>